import { useEffect, useState } from 'react';
import { initializeGTM } from '../services/gtm.service';
import { initializeGA4 } from '../services/ga4.service';
import { initializeGoogleAds } from '../services/ads.service';
import { initializeFacebookPixel } from '../services/facebook.service';
import { initializeTikTokPixel } from '../services/tiktok.service';
import { initializePinterestTag } from '../services/pinterest.service';
import type { AnalyticsConfig } from '../types/analytics.types';

export const useAnalyticsInitialization = (config: AnalyticsConfig) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [initializationError, setInitializationError] = useState<string | null>(null);

  useEffect(() => {
    const initializeAnalytics = async () => {
      try {

        // Inicializa GTM (se configurado)
        if (config.gtm_ids.length > 0) {
          config.gtm_ids.forEach(gtmId => {
            initializeGTM(gtmId);
          });
        }

        // Inicializa GA4 (se configurado)
        if (config.ga4_ids.length > 0) {
          config.ga4_ids.forEach(ga4Id => {
            initializeGA4(ga4Id);
          });
        }

        // Inicializa Google Ads (se configurado)
        if (config.ads_ids.length > 0) {
          config.ads_ids.forEach(adsId => {
            initializeGoogleAds(adsId);
          });
        }

        // Inicializa Facebook Pixel (se configurado)
        if (config.facebook_pixels.length > 0) {
          config.facebook_pixels.forEach(pixelId => {
            initializeFacebookPixel(pixelId);
          });
        }

        // Inicializa TikTok Pixel (se configurado)
        if (config.tiktok_pixels.length > 0) {
          config.tiktok_pixels.forEach(pixelCode => {
            initializeTikTokPixel(pixelCode);
          });
        }

        // Inicializa Pinterest Tag (se configurado)
        if (config.pinterest_tags.length > 0) {
          config.pinterest_tags.forEach(tagId => {
            initializePinterestTag(tagId);
          });

          // Pinterest Tag é global: page() deve ser chamado apenas uma vez
          if ((window as any).pintrk) {
            (window as any).pintrk('page');
          }
        }

        setIsInitialized(true);
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido';
        setInitializationError(errorMessage);
        console.error('❌ Erro na inicialização do Analytics:', error);
      }
    };

    if (config && !isInitialized) {
      initializeAnalytics();
    }
  }, [config, isInitialized]);

  return { isInitialized, initializationError };
}; 